module.exports = require('./helpers/bundle-url').getBundleURL('2YLlC') + "logo.7718c6df.svg";